import { faqData } from '@/mocks/home';

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-question-answer-line"></i>
              常见问题
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见问答
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              关于51吃瓜网的常见问题与详细解答
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {faqData.map((item) => (
              <div
                key={item.id}
                className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-3 flex items-start gap-2">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">Q</span>
                  <span>{item.question}</span>
                </h3>
                <div className="pl-8">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}